import { useQuery } from "react-query";
import axios from '../axios';

const useGetSellerProfile = ({seller_id}) => {
  const query = useQuery(
    ["seller", seller_id],
    async () => {
      try {
        return await axios.get(`/api/sellerprofile/getbyparam?_id=${seller_id}`);
      } catch (error) {
        console.log(error)
      }
    }
  )

  return query;
}

export default useGetSellerProfile;